import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface InvestigacionSiniestro {
  id?: number;
  id_siniestro: number;
  metodologia: string;
  responsable_investigacion: number;
  fecha_inicio: string;
  fecha_cierre?: string | null;
  entrevistas_realizadas?: string;
  evidencia_recolectada?: string;
  reconstruccion_hechos?: string;
  conclusiones?: string;
  estado?: number; // 1 En curso, 2 Cerrada, 0 Inactiva
  fecha_creacion?: string;
  fecha_modificacion?: string | null;
  SiniestroData?: any;
  ResponsableInvestigacionData?: { cedula: string; nombreCompleto: string };
}

@Injectable({
  providedIn: "root",
})
export class InvestigacionSiniestroService {
  private apiUrl = `${environment.apiUrl}/api/investigacion-siniestro`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<InvestigacionSiniestro[]> {
    return this.http
      .get<InvestigacionSiniestro[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getBySiniestroId(idSiniestro: number | string): Observable<InvestigacionSiniestro[]> {
    return this.http
      .get<InvestigacionSiniestro[]>(`${this.apiUrl}/siniestro/${idSiniestro}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getById(id: number | string): Observable<InvestigacionSiniestro> {
    return this.http
      .get<InvestigacionSiniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: InvestigacionSiniestro): Observable<InvestigacionSiniestro> {
    return this.http
      .post<InvestigacionSiniestro>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<InvestigacionSiniestro>): Observable<InvestigacionSiniestro> {
    return this.http
      .put<InvestigacionSiniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  cerrar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/cerrar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  inactivar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}